import LabelProvider from "core/components/label/LabelProvider";
export default LabelProvider.create({

	OpenUser: {
		k: "user.open",
		v: "Open User"
	}
});



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/discussion/OrganizationFlaggedUsers.labels.ts